import { cn } from "@/lib/utils";
import { Avatar } from "@/toggle-ui-kit/avatar";
import { ReportVersion } from "./types";

interface ReportMetaProps {
  meta: Pick<ReportVersion, "version" | "date" | "author" | "relativeTime">;
  /** 작성자 이름 조회 중이면 이메일 대신 스켈레톤을 보여준다. */
  isAuthorLoading?: boolean;
  className?: string;
}

// ============================================
// ReportMeta
// 버전 · 일자 · 상대시각 · 작성자. 메인 행/버전 서브행이 공유한다.
// Figma 시안대로 내용폭(shrink-0)이며, 각 항목도 shrink-0로 gap-16px 균일 배치.
// ============================================

export const ReportMeta = ({ meta, isAuthorLoading, className }: ReportMetaProps) => {
  const { version, date, author, relativeTime } = meta;

  return (
    <div
      className={cn(
        "flex shrink-0 items-center gap-4 caption-1-medium text-label-alternative",
        className,
      )}
    >
      <span className="shrink-0">{version}</span>
      <span className="shrink-0">{date}</span>
      <span className="w-[60px] shrink-0">{relativeTime}</span>
      {/* 아바타+이름을 100px 고정폭 한 덩어리로 묶어 행 간 열 정렬을 유지한다.
          이름은 남는 80px를 채우고, 넘치는 긴 라틴(이메일 앞부분 등)만 …로 자른다. */}
      <div className="flex w-[100px] shrink-0 items-center gap-1">
        {isAuthorLoading ? (
          <span className="h-4 w-12 animate-pulse rounded bg-neutral-200" />
        ) : (
          <>
            <Avatar displayName={author.name} email={author.email} size="16" />
            <span className="min-w-0 flex-1 truncate">{author.name}</span>
          </>
        )}
      </div>
    </div>
  );
};
